var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.tabs'] = (function () {
    'use strict';

    const initialize = (block) => {
        const select = block.querySelector(".form-select");
        if (!select) return;

        // Handle select change show tab
        select.addEventListener("change", function () {
            const value = this.value;
            const activeTabEl = block.querySelector(`[data-bs-target="${value}"]`);
            if (activeTabEl) {
                const tab = new bootstrap.Tab(activeTabEl);
                tab.show();
            }
        });

        // Handle tab shown update select
        block.addEventListener("shown.bs.tab", function () {
            const activeTab = block.querySelector('[data-bs-toggle="tab"].active');
            const activeTarget = activeTab?.getAttribute("data-bs-target");
            if (activeTarget) {
                select.value = activeTarget;
            }
        });
    };

    return {
        initialize
    };

})();